import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getLocaleMessages from '../../utils/localesMessages';
import { copyToClipboard } from '../../lib/copyToClipBoard'; 

const {
	clipboard,
  url: {
    share
  }
} = getLocaleMessages('buttons/buttonCompleteDetails')

class ButtonURL extends Component {
	static propTypes = {
		button: PropTypes.object
	}

	constructor(props) {
		super(props);
	}

	handleCopyToClipboard() {
		copyToClipboard('button-url');
	}

	render() {
		const button_url = this.props.button.email_code + '&source=url';
		
		return (
			<div className="button-detail-body shareable-url">
				<p>{share}</p>
				<textarea
					dir="ltr"
					className="vx_panel-info"
					id="button-url"
					value={button_url} >
				</textarea>
				<div className="clip-board">
					<img src="https://www.paypalobjects.com/images/Cause/ic_copy.svg" />
					<a onClick={this.handleCopyToClipboard}>{clipboard}</a>
				</div>
			</div>
		)
	}
}
export default ButtonURL;



// WEBPACK FOOTER //
// ./buttons/components/buttonDetails/ButtonURL.js